import type { Dictionary } from '@reduxjs/toolkit';
import { ICellRendererFunc, ICellRendererParams } from 'ag-grid-community';
import { startCase } from 'lodash';
import { StatusFieldOption } from 'api/tasks';
import {
  FieldType,
  FilterableField,
  SingleSelectField,
} from 'components/organisms/tasks/fields';
import { getRenderer } from 'components/organisms/tasks/renderers';
import { ProjectFieldsName } from '../../fields';
import { getProjectStatusCellRendererFunc } from '../cell-renderers';
import { None } from './none';

export const groupRowInnerRenderer: ICellRendererFunc = (
  params: Omit<ICellRendererParams, 'value'> & {
    value: string;
    fieldLookByFieldName: Dictionary<FilterableField>;
  },
) => {
  const { node, value, fieldLookByFieldName } = params;

  if (!value) {
    return None;
  }

  if (!node.field) {
    return value;
  }

  const field = fieldLookByFieldName[node.field];

  if (!field) {
    return value;
  }

  const renderer = getRenderer(field);

  switch (field.fieldName) {
    case ProjectFieldsName.startDate:
    case ProjectFieldsName.dueDate:
      /* TODO:: Translate the value instead of using startCase */
      return startCase(value);
    case ProjectFieldsName.status:
      return getProjectStatusCellRendererFunc(
        (field as SingleSelectField).metaData.options as StatusFieldOption[],
      )(params);
    case ProjectFieldsName.inferredProgress:
    case ProjectFieldsName.pastProjectStatus:
      return renderer ? renderer(params) : value;
    default:
      switch (field.type) {
        case FieldType.SingleUser:
        case FieldType.SingleSelect:
          return renderer
            ? renderer({ ...params, value: parseInt(value, 10) })
            : value;
        default:
          return renderer ? renderer(params) : value;
      }
  }
};
